const RECOVERY_PASSWORD_PATH = '/process/recovery-password';

export const getInstitutionalSiteBaseUrl = () => {
  const env = process.env.REACT_APP_ENV;

  if (env === 'prod') {
    return process.env.REACT_APP_SITE_PROD;
  }

  if (env === 'stage') {
    return process.env.REACT_APP_SITE_STAG;
  }

  if (env === 'dev') {
    return process.env.REACT_APP_SITE_DEV;
  }

  return process.env.REACT_APP_SITE_DEV;
};

export const getRecoveryPasswordUrl = () => {
  const baseUrl = (getInstitutionalSiteBaseUrl() || '').replace(/\/$/, '');

  return `${baseUrl}${RECOVERY_PASSWORD_PATH}`;
};
